import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CarUspContainer from "./component";

const mapStateToProps = ({
    carDetails: {
        config
    }
}) => ({
    config
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CarUspContainer);
